import { SiteLinkProps } from "common/ui/SiteLink";
import React from "react";
import { Link } from "react-router-dom"

const AdminUrlResolver = {

    forHome(): string {
        return "/admin";
    },

    forMerchant(merchantId: string): string {
        return `/admin/merchants/${merchantId}`;
    },
    
    forMerchants(): string {
        return '/admin/merchants';
    },
    
    forAddMerchant(): string {
        return '/admin/merchants/new';
    },
    
    forSystemNotifications(): string {
        return '/admin/notifications';
    },

    forRoles(): string {
        return '/admin/roles';
    },

    forRoleDetails(roleId: number): string {
        return `/admin/roles/${roleId}`;
    }
}

const Home = (props: SiteLinkProps) => <Link to={AdminUrlResolver.forHome()} className={props.className}>{props.children}</Link>;

const MerchantDetails = (props: {merchantId: string} & SiteLinkProps) => <Link to={AdminUrlResolver.forMerchant(props.merchantId)} className={props.className}>{props.children ? props.children : props.merchantId}</Link>;
const Merchants = (props: SiteLinkProps) => <Link to={AdminUrlResolver.forMerchants()} className={props.className}>{props.children}</Link>;
const AddMerchant = (props: SiteLinkProps) => <Link to={AdminUrlResolver.forAddMerchant()} className={props.className}>{props.children}</Link>;

const SystemNotifications = (props: SiteLinkProps) => <Link to={AdminUrlResolver.forSystemNotifications()} className={props.className}>{props.children}</Link>;

const Roles = (props: SiteLinkProps) => <Link to={AdminUrlResolver.forRoles()} className={props.className}>{props.children}</Link>;
const RoleDetails = (props: {roleId: number} & SiteLinkProps) => <Link to={AdminUrlResolver.forRoleDetails(props.roleId)} className={props.className}>{props.children}</Link>


export default {
    Home, 

    MerchantDetails,
    Merchants,
    AddMerchant,

    SystemNotifications,

    Roles,
    RoleDetails
};